<template>
  <div class="box">
    <!--滑块-->
    <div href="#">
      <div class="btn" @mousedown="mousedown($event)" @touchstart='mousedown($event)'>{{ ">>" }}</div>
    </div>
    <!--文字-->
    <p class="text" :style="{ color: isok ? 'white' : 'black' }">
      {{ isok ? "验证成功" : "拖动滑块验证" }}
    </p>
    <!--背景-->
    <div class="bg"></div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: "",
  // 局部注册的组件
  components: {},
  // 组件参数 接收来自父组件的数据
  props: {
    isHuman: {
      type: Boolean,
    },
    isMobile: {
      type: Boolean,
    },
  },
  // 组件状态值
  data() {
    return {
      isok: false,
      btn: null,
      box: null,
      bg: null,
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {
    isok() {
      console.log(this.isok);
      if (!this.isok) {
        this.bg.style.width = 0 + "px"; //背景
        this.btn.style.left = 0;
      }
    },
  },
  // 生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    this.$nextTick(() => {});
  },
  /**
   * el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.el 也在文档内。
   */
  mounted() {},
  // 组件方法
  methods: {
    mousedown(e) {
      if (this.isok) {
        return;
      }
      let that = this;
      let btn = document.querySelector(".btn");
      let box = document.querySelector(".box");
      let bg = document.querySelector(".bg");
      this.btn = btn;
      this.box = box;
      this.bg = bg;
      let downX;
      console.log(e);
      if (e.type == "mousedown") {
        downX = e.clientX;

        btn.onmousemove = function (event) {
          console.log(event);
          let moveX = event.clientX - downX;
          //移动范围
          if (moveX > -2) {
            this.style.left = moveX + "px"; //将移动值赋值给滑块
            bg.style.width = moveX + "px"; //背景
            if (moveX >= box.offsetWidth - btn.offsetWidth) {
              //包含原始宽度内边距边框，不包含外边框
              //拖到头，验证成功
              console.log("--------------------------------------------");
              that.isok = true;
              that.$emit("update:isHuman", that.isok);
              //事件清除
              btn.onmousedown = null;
              btn.onmousemove = null;
            }
          }
        };
        btn.onmouseup = function () {
          //事件清除
          btn.onmousemove = null;
          if (that.isok) return;
          this.style.left = 0; //将移动值赋值给滑块
          bg.style.width = 0; //背景
        };
      } else {
        downX = e.touches[0].clientX;
        btn.ontouchmove = function (event) {
          let moveX = event.touches[0].clientX - downX;
          //		console.log(moveX);
          console.log(moveX);
          console.log(event);

          //移动范围
          if (moveX > -2) {
            this.style.left = moveX + "px"; //将移动值赋值给滑块
            bg.style.width = moveX + "px"; //背景
            if (moveX >= box.offsetWidth - btn.offsetWidth) {
              //包含原始宽度内边距边框，不包含外边框
              //拖到头，验证成功
              that.isok = true;
              that.$emit("update:isHuman", that.isok);
              //事件清除
              btn.ontouchstart = null;
              btn.ontouchmove = null;
            }
          }
        };
        btn.ontouchend = function () {
          //事件清除
          btn.ontouchmove = null;
          if (that.isok) return;
          this.style.left = 0; //将移动值赋值给滑块
          bg.style.width = 0; //背景
        };
      }
      // btn.onmousedown = function (e) {

      // };
    },
  },
};
</script>

<style scoped lang="less">
.box {
  position: relative;
  width: 235px;
  height: 34px;
  background: #e8e8e8;
  border-radius: 4px;
  left: 0px;
}
.btn {
  position: absolute;
  top: 0;
  width: 40px;
  height: 34px;
  user-select: none;

  text-align: center;
  line-height: 32px;
  border-radius: 4px;
  z-index: 3;
  background-color: #fff;
  border: 1px solid #ccc;
  color: black;
  cursor: pointer;
}
.text {
  position: absolute;
  user-select: none;
  width: 100%;
  margin: 0;
  text-align: center;
  line-height: 34px;
  display: block;
  z-index: 2;
  /*-webkit-margin-before: 1em;
	-webkit-margin-after: 1em;*/
}
.bg {
  position: absolute;
  height: 100%;
  background-color: yellowgreen;
  z-index: 1;
}
</style>
